<div class="modal-content">
    <div class="row">
        <div class="col-sm-12" *ngIf="closeButton == true">
            <button class="close mr-4 mt-2" type="button" (click)="close()"><i class="fa fa-times"></i></button>
        </div>
    </div>

    <div class="modal-header my-3 pl-5">
        <h4 *ngIf="title">{{title || ''}}</h4>
        <span *ngIf="subtitle">{{subtitle || ''}}</span>
    </div>
    <div class="row">
        <div class="col-12">
            <app-alert-message *ngFor="let message of messages; let i = index"
                [message]="message.text"
                [isError]="message.isError"
                [isSuccess]="message.isSuccess"
                (close)="removeMessage(i)"
            ></app-alert-message>
        </div>
    </div>
    <div class="modal-body px-5" *ngIf="form && form.length > 0">
        <form [formGroup]="formComponent" class="row">
            <div [ngClass]="form.length > 3 ? 'col-sm-12 col-md-6' : 'col-sm-12 col-md-10 mx-auto'" *ngFor="let item of form; let i = index">
                <ng-container [ngSwitch]="item.type">

                    <ng-container *ngSwitchCase="'date'">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label class="text-overflow-ellipsis">{{item.label || item.key || ''}}</mat-label>
                            <input matInput 
                                [matDatepicker]="picker" 
                                formControlName="{{item.key}}"
                                [placeholder]="item.placeholder || item.label || item.key || ''"
                                [value]="item.value || ''"
                            >
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngSwitchCase="'dateTime'">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>Fecha y hora</mat-label>
                            <input matInput type="datetime-local" formControlName="{{item.key}}"
                                [placeholder]="item.placeholder || item.label || item.key || ''"
                                [value]="item.value || ''">
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngSwitchCase="'textarea'">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>{{item.label || item.key || ''}}</mat-label>
                            <textarea matInput 
                                formControlName="{{item.key}}"
                                [placeholder]="item.placeholder || item.label || item.key || ''"
                                [value]="item.value || ''"
                            ></textarea>
                        </mat-form-field>
                    </ng-container>
                    
                    <ng-container *ngSwitchCase="'select'">
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>{{item.label || item.key || ''}}</mat-label>
                            <mat-select formControlName="{{item.key}}">
                                <mat-option *ngFor="let option of item.options" [value]="option.value">
                                     {{option.label || option.value}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                        <mat-form-field class="w-100" appearance="outline">
                            <mat-label>{{item.label || item.key || ''}}</mat-label>
                            <input matInput 
                                formControlName="{{item.key}}"
                                [type]="item.type || 'text'"
                                [placeholder]="item.placeholder || item.label || item.key || ''"
                                [value]="item.value || ''"
                            >
                            <button type="button" matSuffix mat-icon-button 
                                aria-label="Clear" 
                                (click)="clearControl(item.key)"
                                *ngIf="formComponent.get(item.key)?.value"
                            >
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </ng-container>
                </ng-container>
            </div>
        </form>
    </div>
    <div class="modal-footer d-flex justify-content-center my-3 bg-white" *ngIf="cancelButton || confirmButton">
        <button type="button" class="custom-button-secondary-fixed mx-2" (click)="close()" mat-flat-button *ngIf="cancelButton">
            {{cancelButton || 'Cancelar'}}
        </button>
        <button type="button" class="custom-button-tertiary mx-2" (click)="confirm()" mat-flat-button *ngIf="confirmButton">
            {{confirmButton || 'Aceptar'}}
        </button>
    </div>
</div>